import React, { useState, useEffect } from "react";
import { BASE_URL } from "../../services/api";

const API_ADD = `${BASE_URL}Pages/BankReg.php`;
const API_VIEW = `${BASE_URL}Pages/BankView.php`;

export default function Banks({ user }) {
  const companyId = user?.Companyid || user?.company_id || "1";

const emptyForm = {
  Companyid: companyId,
  Bank: "",
  AccHolder: "",
  AccNumber: "",
  IFSC: "",
  AccType: "Savings",
  Status: "Active",
  Branch: "",
  IDS: "0"
};

const [form, setForm] = useState(emptyForm);
const [banks, setBanks] = useState([]);
const [loading, setLoading] = useState(false);
const [showForm, setShowForm] = useState(false);

/* ================= INPUT CHANGE ================= */

const handleChange = (e) => {

  const { name, value } = e.target;

  setForm(prev => ({
    ...prev,
    [name]: value
  }));

};

/* ================= VALIDATION ================= */

const validateForm = () => {

  if (!form.Bank.trim()) {
    alert("Bank Name is required");
    return false;
  }

  if (!form.AccHolder.trim()) {
    alert("Account Holder is required");
    return false;
  }

  if (!form.AccNumber.trim()) {
    alert("Account Number is required");
    return false;
  }

  if (!form.IFSC.trim()) {
    alert("IFSC Code is required");
    return false;
  }

  if (!form.Branch.trim()) {
    alert("Branch is required");
    return false;
  }

  if (!form.AccType) {
    alert("Account Type is required");
    return false;
  }

  if (!form.Status) {
    alert("Status is required");
    return false;
  }

  return true;

};

/* ================= FETCH BANKS ================= */

const fetchBanks = async () => {

  try {

    const res = await fetch(API_VIEW, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ Companyid: companyId })
    });

    const data = await res.json();

    if (data.success) {

      const list = Array.isArray(data.Response)
        ? data.Response
        : [data.Response];

      setBanks(list);

    }

  } catch (err) {

    console.error("Bank fetch error:", err);

  }

};

/* ================= SAVE / UPDATE ================= */

const handleSave = async () => {

  if (!validateForm()) return;

  try {

    setLoading(true);

    const res = await fetch(API_ADD, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...form, Companyid: companyId })
    });

    const data = await res.json();

    if (data.success) {

      alert("Bank Saved Successfully");

      fetchBanks();
      setShowForm(false);
      setForm(emptyForm);

    } else {

      alert(data.message);

    }

  } catch (err) {

    console.error(err);
    alert("Server Error");

  } finally {

    setLoading(false);

  }

};

/* ================= ADD NEW ================= */

const handleAddNew = () => {

  setForm(emptyForm);
  setShowForm(true);

};

/* ================= EDIT ================= */

const handleEdit = (row) => {

  setForm({
    Companyid: companyId,
    Bank: row.Bank || "",
    AccHolder: row.AccHolder || "",
    AccNumber: row.AccNumber || "",
    IFSC: row.IFSC || "",
    AccType: row.AccType || "Savings",
    Status: row.Status || "Active",
    Branch: row.Branch || "",
    IDS: row.Bankid
  });

  setShowForm(true);

  window.scrollTo({ top: 0, behavior: "smooth" });

};

useEffect(() => {
  fetchBanks();
}, [companyId]);

/* ================= UI ================= */

return (

<div className="pump-page">

{/* HEADER */}

<div className="page-header">

<h2 className="page-title">Master / Bank</h2>

<button className="btn btn-primary btn-sm" onClick={handleAddNew}>
＋ Add New
</button>

</div>


{/* FORM */}

{showForm && (

<div className="section-card">

<div className="section-header">
{form.IDS === "0" ? "Add Bank" : "Edit Bank"}
</div>

<div className="form-row">

<div className="form-group">
<label>Bank Name <span className="required">*</span></label>
<input
className="form-control"
name="Bank"
value={form.Bank}
onChange={handleChange}
/>
</div>

<div className="form-group">
<label>Account Holder <span className="required">*</span></label>
<input
className="form-control"
name="AccHolder"
value={form.AccHolder}
onChange={handleChange}
/>
</div>

<div className="form-group">
<label>Account Number <span className="required">*</span></label>
<input
className="form-control"
name="AccNumber"
value={form.AccNumber}
onChange={handleChange}
/>
</div>

<div className="form-group">
<label>IFSC <span className="required">*</span></label>
<input
className="form-control"
name="IFSC"
value={form.IFSC}
onChange={handleChange}
/>
</div>

<div className="form-group">
<label>Branch <span className="required">*</span></label>
<input
className="form-control"
name="Branch"
value={form.Branch}
onChange={handleChange}
/>
</div>

<div className="form-group">
<label>Account Type <span className="required">*</span></label>
<select
className="form-control"
name="AccType"
value={form.AccType}
onChange={handleChange}
>
<option value="">Select Type</option>
<option value="Savings">Savings</option>
<option value="Current">Current</option>
</select>
</div>

<div className="form-group">
<label>Status <span className="required">*</span></label>
<select
className="form-control"
name="Status"
value={form.Status}
onChange={handleChange}
>
<option value="">Select Status</option>
<option value="Active">Active</option>
<option value="Inactive">Inactive</option>
</select>
</div>

</div>

<div className="action-bar">

<button className="btn btn-primary" onClick={handleSave} disabled={loading}>
💾 {form.IDS === "0" ? "Save Bank" : "Update Bank"}
</button>

<button
className="btn btn-secondary"
onClick={() => {
  setForm(emptyForm);
  setShowForm(false);
}}
>
✕ Cancel
</button>

</div>

</div>

)}


{/* TABLE */}

<div className="section-card">

<div className="section-header">
Bank List — {banks.length} records
</div>

<div className="table-wrapper">

<table className="data-table">

<thead>
                <tr>
                  <th className="text-left">Bank</th>
                  <th className="text-left">Account Holder</th>
                  <th className="text-center">Account Number</th>
                  <th className="text-center">IFSC</th>
                  <th className="text-left">Branch</th>
                  <th className="text-center">Type</th>
                  <th className="text-center">Status</th>
                  <th className="text-left">Company</th>
                  <th className="text-center">Action</th>
                </tr>
</thead>

<tbody>

{banks.map(row => (

                  <tr key={row.Bankid}>
                    <td className="text-left" style={{ fontWeight: 600 }}>{row.Bank}</td>
                    <td className="text-left">{row.AccHolder}</td>
                    <td className="text-center" style={{ fontFamily: 'monospace' }}>{row.AccNumber}</td>
                    <td className="text-center" style={{ fontFamily: 'monospace' }}>{row.IFSC}</td>
                    <td className="text-left">{row.Branch}</td>
                    <td className="text-center">
                      <span className="badge badge-info">{row.AccType}</span>
                    </td>
                    <td className="text-center">
                      <span className={`badge ${row.Status === 'Active' ? 'badge-success' : 'badge-warning'}`}>
                        {row.Status}
                      </span>
                    </td>
                    <td className="text-left" style={{ fontSize: '0.85rem', color: 'var(--text-secondary)' }}>{row.CompanyName}</td>
                    <td className="text-center">
                      <button className="icon-btn" onClick={() => handleEdit(row)}>
                        <i className="bi bi-pencil-square"></i>
                      </button>
                    </td>
                  </tr>

))}

</tbody>

</table>

</div>

</div>

</div>

);

}